import { takeLatest, call, put } from 'redux-saga/effects'
import Api from '../../api'
import { handleResponseError } from '../create-request-saga'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'

// action types
const RECEIVE_BULK_PAYMENTS_LIST_MODAL =
  'rp/BulkPaymentsListModal/RECEIVE_BULK_PAYMENTS_LIST_MODAL'
const REQUEST_BULK_PAYMENTS_LIST_MODAL =
  'rp/BulkPaymentsListModal/REQUEST_BULK_PAYMENTS_LIST_MODAL'

// reducer
export default (state = [], { type, payload }) => {
  switch (type) {
    case RECEIVE_BULK_PAYMENTS_LIST_MODAL:
      return [...payload.payments]
    default:
      return state
  }
}

// action creators
export const requestBulkPaymentsListModal = payload => ({
  type: REQUEST_BULK_PAYMENTS_LIST_MODAL,
  payload,
})

export const receiveBulkPaymentsListModal = payload => ({
  type: RECEIVE_BULK_PAYMENTS_LIST_MODAL,
  payload,
})

// sagas
function* fetchBulkPaymentsListModal({ payload }) {
  try {
    const bulk_payments_list_group = yield call(Api.getBulkPaymentsListGroup, {
      payment_group_id: payload.payment_group_id,
    })
    yield put(receiveBulkPaymentsListModal(bulk_payments_list_group))
  } catch (error) {
    yield call(handleResponseError, error, { key: 'bulkPaymentsListModal' })
  } finally {
    yield payload.callback &&
      typeof payload.callback == 'function' &&
      payload.callback()
  }
}

function* watchBulkPaymentsListModal() {
  yield takeLatest(
    REQUEST_BULK_PAYMENTS_LIST_MODAL,
    createRequestSaga(fetchBulkPaymentsListModal, {
      key: 'payment_details',
      messgae: __('Looking up payment settings'),
      duration: 500,
    }),
  )
}

export const sagas = [watchBulkPaymentsListModal]
